import { useAuth } from "hooks/hooks";

const notificationCenterAllowedTIDs = new Set<string>([
	"3eaaf1d3-6f9e-40fd-b7e9-60b45e55e125",
	"dff04b02-c61b-4f4f-8cd5-2b9c6b379752",
]);
export const useFeatureFlag = (featureFlagName: string): boolean => {
	const {
		auth: {
			account: { tenantId: authTenantId },
		},
	} = useAuth();

	// Placeholder implementation for feature flag checking
	// In a real application, this would check against a feature flag service or configuration
	const featureFlags: Record<string, boolean> = {
		"notification-center": notificationCenterAllowedTIDs.has(authTenantId),
	};

	return featureFlags[featureFlagName] ?? false;
};
